import React from "react";
import { Stack, ThemeProvider } from "@mui/material";
import { Box } from "@mui/system";
import { Outlet } from "react-router-dom";

import { ReactComponent as Logo } from "../../../Assets/Images/logo/Logo.svg";
import { ReactComponent as Verifiedoc } from "../../../Assets/Images/Verified-doc.svg";
import { Theme } from "../../../Style/Theme";
import TopNavigationBar from "../../molecules/TopNavigationBar/TopNavigationBar";

const ContentVerification = () => {
  const isMobile = window.innerWidth <= 768;
  
  return (
    <div style={{
      padding: isMobile ? '20px 16px' : '10px 8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      borderRadius: '8px',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Wrapper with responsive width */}
      <div style={{ 
        width: isMobile ? '100%' : '500px', 
        maxWidth: '500px',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}>
        {/* Document Icon */}
        <div style={{ position: 'relative', marginBottom: isMobile ? '24px' : '32px' }}>
          <Verifiedoc 
            width={isMobile ? "100" : "120"} 
            height={isMobile ? "100" : "120"}
            style={{ display: 'block' }}
          />
        </div>
        
        {/* Verification text */}
        <p style={{
          fontSize: isMobile ? '12px' : '18px',
          fontWeight: '500',
          color: '#333',
          textAlign: 'center',
          margin: '0',
          maxWidth: '400px',
          lineHeight: '1.5',
          fontStyle: 'oblique',
        }}>
          This is a verified document issued by FirstDoctor.
        </p>
      </div>
    </div>
  );
};

const AuthLayout = () => {
  const isMobile = window.innerWidth <= 768;
  
  return (
    <ThemeProvider theme={Theme}>
      <Box
        height={"100vh"}
        width={"100%"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
        bgcolor={Theme.palette.background.offWhite}
      >
        <TopNavigationBar
          justifyContent={"center"}
          backgroundColor={Theme.palette.background.pureWhite}
          minHeight={"68px"}
        >
          <Logo type="img" role="img" width={isMobile ? '150px' : '190px'} height={isMobile ? '50px' : "64px"}/>
        </TopNavigationBar>
        
        <Stack
          style={{
            width: isMobile ? "calc(100% - 32px)" : "calc(100% - 64px)",
            height: "auto",
            borderRadius: isMobile ? "12px" : "16px",
            backgroundColor: "white",
            margin: isMobile ? "16px" : "32px",
            marginTop: isMobile ? "75px" : "91px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Outlet />
        </Stack>
      </Box>
    </ThemeProvider>
  );
};

const AppWithoutRouting = () => {
  const isMobile = window.innerWidth <= 768;
  
  return (
    <ThemeProvider theme={Theme}>
      <Box
        height={"100vh"}
        width={"100%"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
        bgcolor={Theme.palette.background.offWhite}
      >
        <TopNavigationBar
          justifyContent={"center"}
          backgroundColor={Theme.palette.background.pureWhite}
          minHeight={"68px"}
        >
          <Logo type="img" role="img" width={isMobile ? '150px' : '190px'} height={isMobile ? '50px' : "64px"}/>
        </TopNavigationBar>
        
        <Stack
          style={{
            width: isMobile ? "calc(100% - 32px)" : "calc(100% - 64px)", // Smaller margins on mobile
            height: isMobile ? "calc(100% - 107px)" : "calc(100% - 123px)", // Adjust for mobile
            borderRadius: isMobile ? "12px" : "16px", // Slightly smaller radius on mobile
            backgroundColor: "white",
            margin: isMobile ? "16px" : "32px",
            marginTop: isMobile ? "75px" : "91px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ContentVerification />
        </Stack>
      </Box>
    </ThemeProvider>
  );
};

export { ContentVerification, AuthLayout, AppWithoutRouting };
export default AppWithoutRouting;